import React, { Fragment, useEffect } from "react";
import Loading from "components/explore/prospector/layout/Loading";
import PropertyDetails from "components/explore/prospector/addProperty/PropertyDetails"
import MapCard from "components/explore/prospector/map/MapCard";
import { withSnackbar } from 'notistack';
import { Redirect } from "react-router-dom";
import PageWrapper from "components/explore/prospector/layout/PageWrapper";
import Page from "components/explore/prospector/layout/Page";
import { Constants } from 'utilities/constants';
import { getPlaceDetails, getSessionToken } from "api/prospector/places";

let isMounted = false;

function AddPropertyPage({ history, match, enqueueSnackbar, refreshProspectsGrid, setRefreshProspectsGrid }) {
    const [details, setDetails] = React.useState(null);
	const [token] = React.useState(getSessionToken());
    const placeId = match.params.placeId;
    console.log('propertypage', placeId);
    async function fetchPlaceDetails() {
        if (!placeId) return;
        try {
            const placeDetails = await getPlaceDetails(placeId, token);
            if (placeDetails.success && isMounted) setDetails(placeDetails.data);
            
            if (!placeDetails.success) {
                enqueueSnackbar(placeDetails.message, {
                    variant: 'error',
                    autoHideDuration: 3000
                });

                setDetails('redirect');
            }
        } catch (err) {
            console.error(err);
            enqueueSnackbar("Failed to load property details", { variant: "error", autoHideDuration: 3000 });
            setDetails("redirect");
        }
    }
    useEffect(() => {
        isMounted = true;
        fetchPlaceDetails();
        return () => isMounted = false;
    }, []);
    // const loading = details == null;
    function renderLoading() {
        return (
            <Loading message="Loading Property Info" />
        )
    }
    
    function renderDetails(details) {
        return (
            <Fragment>
                <MapCard pin={details.location} details={details}/>
                <PropertyDetails history={history} details={details} refreshProspectsGrid={refreshProspectsGrid} setRefreshProspectsGrid={setRefreshProspectsGrid} />
            </Fragment>
        )
    }
    if (details === "redirect") {
        return (
            <Redirect to={Constants.Routes.EXPLORE_PROSPECTOR} />
        );
    }

    return (
        <Page>
            <PageWrapper>
                {details == null ? renderLoading() : renderDetails(details)}
            </PageWrapper>
        </Page>
    )
}

export default withSnackbar(AddPropertyPage);